import * as React from 'react';
import ApplicationState from 'src/application/core/State';
import { connect } from 'react-redux';
import TableHeader from '../../TableHeader';
import '../../CustomTable.css';
import '../../Summary.css';
import '../PrintEstimationDetails.css';
import SummaryDetails, { SummaryData } from '../../SummaryDetails';
import UserEstimationDetails, { ItemDetail, ItemDetailToExport } from '../../../domain/SummaryData';
import DispatchProps, { mapDispatchToProps } from 'src/application/core/DispatchProps';
import ItemDetails from '../../ItemDetails';
import triggerClickOnExcelDownload from '../../triggerClickOnExcelDownload';
import ExportDataToExcel, { Column } from '../../ExportDataToExcel';
import createExcelFileName from '../../createExcelFileName';
import Product from '../../../domain/Product';
import createDetailsExcelData from '../../createDetailsExcelData';
import Role from '../../../domain/Role';
import formatNumber, { formatPrice } from '../../formatNumber';
import Loader from '../../common/Loader';

interface StateProps {
    estimation: UserEstimationDetails | null;
    products: Product[];
    role: Role;
}

interface State {
    spreadsheetData: ItemDetailToExport[];
}

interface Props {
    goBackLink: JSX.Element;
}

class ViewEstimation extends React.PureComponent<Props & StateProps & DispatchProps, State> {
    private headers = ['Name', 'Qty', 'Price', 'SKU', 'Subtotal'];

    constructor(props: Props & StateProps & DispatchProps) {
        super(props);
        this.state = {
            spreadsheetData: []
        };
    }

    public render(): JSX.Element {
        const spreadsheetColumns: Column[] = [
            {
                label: 'SKU',
                value: 'sku'
            },
            {
                label: 'Name',
                value: 'name'
            },
            {
                label: 'Variant code',
                value: 'variantCode'
            },
            {
                label: 'Size',
                value: 'size'
            },
            {
                label: 'Quantity',
                value: 'quantity'
            },
            {
                label: 'Price',
                value: 'discountedPrice'
            },
            {
                label: 'Package size',
                value: 'packageSize'
            },
            {
                label: 'Subtotal',
                value: 'subTotal'
            }
        ];

        return this.props.estimation ? (
            <div className="summary-container">
                <SummaryDetails data={this.getDetailsData()} goBackLink={this.props.goBackLink} onExportClicked={this.onExportClicked} />
                <ExportDataToExcel
                    spreadsheetData={this.state.spreadsheetData}
                    columns={spreadsheetColumns}
                    name="Estimation"
                    filename={createExcelFileName('Estimation', new Date(), this.props.estimation.placeDate)}
                />
                <div className="custom-table">
                    <TableHeader headers={this.headers} class={'custom-table-header'} />
                    <div className="custom-table-body">
                        {this.props.estimation.items.map((item: ItemDetail) => (
                            <ItemDetails item={item} key={item.sku} />
                        ))}
                    </div>
                </div>
                <div className="print-container">
                    <div className="total-amount">
                        <div className="text">Total amount</div>
                        <div className="value">{this.calculateTotalAmount()} pcs</div>
                    </div>
                    <div className="grand-total">
                        <div className="text">Grand total</div>
                        <div className="value">€ {this.getTotalCost()}</div>
                    </div>
                </div>
            </div>
        ) : (
            <Loader />
        );
    }

    private onExportClicked = (): void => {
        this.setState({ spreadsheetData: createDetailsExcelData(this.props.estimation!.items) }, () => {
            triggerClickOnExcelDownload('estimations-download-button');
            this.setState({ spreadsheetData: [] });
        });
    };

    private getDetailsData = (): SummaryData[] => [
        { text: 'Estimation no', value: this.props.estimation!.id },
        { text: 'Estimation date', value: this.props.estimation!.placeDate },
        {
            text: 'Delivery drop',
            value: this.props.estimation!.deliveryDrop.month + '/' + this.props.estimation!.deliveryDrop.year
        },
        { text: 'Est. Quantity', value: formatNumber(this.props.estimation!.quantity, 0) },
        {
            text: 'Total cost',
            value: formatPrice(this.props.estimation!.totalCost)
        }
    ];

    private getTotalCost = (): string => formatPrice(this.props.estimation!.totalCost);

    private calculateTotalAmount = (): number => {
        if (this.props.estimation !== null) {
            let totalAmount = 0;
            this.props.estimation.items.forEach((item: ItemDetail) => {
                totalAmount += item.quantity;
            });
            return totalAmount;
        } else {
            return 0;
        }
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    estimation: state.estimationDetails,
    products: state.products.estimationProducts,
    role: state.user.role
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewEstimation);



// WEBPACK FOOTER //
// ./src/view/estimations/details/ViewEstimation.tsx